export const navigationItems = [
    { href: "#home", text: "Home", iconClass: "uil-estate" },
    { href: "#about", text: "About", iconClass: "uil-user" },
    { href: "#services", text: "Services", iconClass: "uil-briefcase-alt" },
    { href: "#skills", text: "Skills", iconClass: "uil-file" },
    { href: "#works", text: "Projects", iconClass: "uil-scenery" },
    { href: "#contact", text: "Contact", iconClass: "uil-message" },
];